const locale = {
  placeholder: 'SÃ©lectionner l\'heure',
};

export default locale;
